export const getSelectedValues = (tableStore) => {
    if (tableStore.isSelectAll) {
        return tableStore.data.filter(item => {
            if (tableStore.excludedRowsIds.has(item[tableStore.primaryKeyFieldInDb])) return false;
            return !tableStore.isRowSelectable || tableStore.isRowSelectable(item);
        });
    }
    return Array.from(tableStore.selectedObjectsMap.values());
};
